import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ variables, palette }) => ({
  restaurantName: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '180px',
    minHeight: '50px',
    backgroundColor: `${palette.jet?.containerDefault}`,
    position: 'absolute',
    marginLeft: '-77px',
    marginTop: '-56px',
    borderRadius: '4px',
    boxShadow:variables?.elevation01,
    '& .jetFontIcon':{
        color:palette?.jet?.interactiveBrand
    },
    paddingLeft:variables?.spacingC,
    paddingRight:variables?.spacingC,
    wordBreak:'break-word'
  },
}));

export default styles;
